import React,{useState,useEffect} from 'react';
import { Table,Spin,Skeleton } from 'antd';
import { Link ,useLocation} from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons';
import {getData } from '../../config/api-connect';
import * as Styled from './style.js';
import Spinner from '../../components/spinner'

const HotLeads = ({ cities,venueId,hotLeadsRef }) => {
  const location = useLocation();
  const [leadData, setLeadData] = useState([])
  const [pageLoading, setPageLoading] = useState(true)

  useEffect(()=>{
    if(cities !== ''){
      getLeadDetails()
    }
  },[cities,venueId])

  const columns = leadData.length > 0 ? 
    [
        ...Object.keys(leadData[0]).filter(key => key !== 'venue_id').map(key => ({
            title: key == 'verbal_confirm' ? 'Verbal Confirmation' : key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' '),  
            dataIndex: key,
            key: key,
            align: key !== 'venue' && 'center',
            sorter: key !== 'venue' ? (a, b) => a[key] - b[key] : false,
            render: key === 'venue' ? 
            (text, record) => (
                <Link to={`/leadList/${record.venue_id}`} className='venueTitle'>
                {record.venue}
                </Link>
            )
            : 
            text => text
        })),
        {
            title: '',
            dataIndex: 'venue_id',
            render: (value) => (
            <Link to={`/leadList/${value}`} className='venueTitle'>
                <ArrowRightOutlined/>
            </Link>
            )
        }
    ]
    : [];

    const getLeadDetails = async () => {
      setPageLoading(true)
      await getData(`/business/get_hot_leads_overview/?venue_id=${venueId}&city_id=${cities}`)
      .then(response =>{
        setLeadData(response.result)
        setPageLoading(false)
      })
      .catch(error => {
        console.log(error.message);
        setPageLoading(false)
      })
    }

    return (
      <div ref={hotLeadsRef}>
        <Styled.Header>
            <span>Pending To Process - Today</span>
        </Styled.Header>
        {
          pageLoading ?
            <Skeleton active paragraph={{ rows: 7 }} title={false} />
          :  
          <Table
              className="ant-table-thead table_container"
              rowKey="id"
              columns={columns}
              dataSource={leadData}
              pagination={{ pageSize: 10, showSizeChanger: false}}
              summary={() => {
                  const totalRow = {};
                  const excludeKeys = ['venue', 'venue_id'];
                  const totalCount = leadData.length;

                  if (totalCount > 0) {
                    Object.keys(leadData[0]).forEach((key) => {
                      if (!excludeKeys.includes(key)) {
                        const isNumber = typeof leadData[0][key] === 'number';
                        if (isNumber) {
                          const total = leadData.reduce((sum, item) => {
                            return sum + item[key];
                          }, 0);
                          totalRow[key] = total;                        
                        }
                      }
                    });
                  }
                  else{
                    return null
                  }
                  return (
                    <Table.Summary.Row>
                      {columns.map((col, index) => {
                        const key = col.dataIndex;

                        if (index === 0) {
                          return (
                            <Table.Summary.Cell key={key}><b>Total</b></Table.Summary.Cell>
                          );
                        }

                        if (key === 'venue_id') {
                          return <Table.Summary.Cell key={key} />;
                        }

                        return (
                          <Table.Summary.Cell key={key} align="center">
                            {totalRow.hasOwnProperty(key) ? (
                              <b>{totalRow[key]}</b>
                            ) : ''}
                          </Table.Summary.Cell>
                        );
                      })}
                    </Table.Summary.Row>
                  );
                }}
          />
        }
      </div>
    );
};

export default HotLeads;